module.exports = __webpack_public_path__ + "img/pms8.a3689fc5.jpg";